import { inject } from '@angular/core';
import {
    ActivatedRouteSnapshot,
    Router,
    RouterStateSnapshot,
} from '@angular/router';
import { StepNavigationService } from '../../services/step-navigation/step-navigation.service';
import { RouteConstants } from '../../../../../core/constants/routes';
import { of, Observable, take, tap, map, catchError } from 'rxjs';
import { navigateToHome } from '../../../../../core/resolver/shared/functions/navigate-to-home.function';
import { ApplicationService } from '../../services/application/application.service';

export const CurrentStepResolver = (
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
): Observable<boolean> => {
    const stepNavigationService = inject(StepNavigationService);
    const applicationService = inject(ApplicationService);
    const router = inject(Router);

    const applicationId = route?.paramMap.get('id');
    const url = state.url;

    if (
        url.includes(
            `/${RouteConstants.Application.rootUrl}/${RouteConstants.Application.newApplicationBaseUrl}/`,
        )
    ) {
        stepNavigationService.initializeNewApplicationSteps();
        stepNavigationService.setCurrentStepByPath(url);

        return of(true);
    } else if (url.includes(`/${RouteConstants.Go.newApplicationRootUrl}/`)) {
        stepNavigationService.initializeGoNewApplicationPreparationSteps();
        stepNavigationService.setCurrentStepByPath(url);

        return of(true);
    }

    if (!applicationId) {
        console.log(
            'Tried to navigate to application page but Application ID is not defined.',
        );

        return navigateToHome(router);
    }

    // Set application state for any steps that have an application ID
    return applicationService.getApplicationState(applicationId).pipe(
        take(1),
        tap(() => {
            if (
                RouteConstants.Go.isParametersRoute(url) ||
                RouteConstants.Go.isConfirmParametersRoute(url)
            ) {
                stepNavigationService.initializeGoApplicationPreparationSteps(
                    applicationId,
                );
            } else if (
                url.includes(
                    `/${RouteConstants.Application.coordinationBaseUrl}/`,
                )
            ) {
                stepNavigationService.initializeCoordinationSteps(
                    applicationId,
                );
            } else if (
                url.includes(`/${RouteConstants.Go.applicationRootUrl}`)
            ) {
                stepNavigationService.initializeGoApplicationSteps(
                    applicationId,
                );
            } else {
                throw new Error(
                    `'Application URL: ${url} is not the first page of any application type.`,
                );
            }

            stepNavigationService.setCurrentStepByPath(url);
        }),
        map(() => true),
        catchError((error) => {
            console.error('Error initializing current step:', error);
            return navigateToHome(router);
        }),
    );
};
